import React, { useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { ButtonCreate, LeftSide, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from "../../../components/styles/subheader-style";
import vehicles_act from '../../../assets/router/routersTabHeader/vehicle-active.svg';
import RouterButtons from "../router/routerButtons";
import { Content } from "../router/style";
import { TypeMainOutlet } from "..";
import { Button } from "react-bootstrap";
export interface EquipmentOutletType {
    tabIndex: number
    setTabIndex: React.Dispatch<React.SetStateAction<number>>
  }

  const tabs = [
    // {path: 'machine', image: vehicles_act, name: 'Máquinas'},
    {path: 'vehicles', image: vehicles_act, name: 'Veículos'},
]
  const EquipmentSubHeader:React.FC<{tabIndexActived:number}> = ({tabIndexActived})=>{
    const navigate = useNavigate() 
    const location = useLocation();
    const criarVeiculo = ()=>{
    
        navigate('/panel/equipment/create')
        
    }
    return(
        <SubHeaderContainer>
        <LeftSide>
            <SectionName>Veículos</SectionName>
       
        <TabsDiv style={{visibility:'hidden'}}>
        {tabs.map((tab, index) => (
        <Tab
          key={index}
          $isFirst={index === 0}
          $isLast={index === tabs.length - 1}
          $isActive={index === tabIndexActived}
          onClick={() => {
            if(index !== tabIndexActived) navigate(tab.path)
          }}
        >
            <img src={tab.image} alt={`${tab.path}-icon`} />
            {tab.name}
        </Tab>
        ))}
      </TabsDiv >
        </LeftSide>
        <RightSide>
          <ButtonCreate onClick={criarVeiculo}>+ Criar Veículo</ButtonCreate>
        </RightSide>
        </SubHeaderContainer>
    )
} 
const EquipmentContent = ()=>{
    // const [loading, setLoading] = useState<boolean>(true)
    const [ tabIndex, setTabIndex ] = useState<number>(0)
    const { search } = useOutletContext<TypeMainOutlet>()
   
    return (
        <>
        
        <EquipmentSubHeader tabIndexActived={tabIndex}/>
        <Content>
        <Outlet
            context={{
              tabIndex,
              setTabIndex,
              search
            }}
          />
        </Content>
        </>
    )
}
export default EquipmentContent